import { NgModule } from "@angular/core";
import { Routes,RouterModule } from "@angular/router";
import { HomeHealthAgencyComponent } from "./home-health-agency.component";

const routes: Routes = [{path:'',component:HomeHealthAgencyComponent}];


@NgModule({
    imports:[RouterModule.forChild(routes)],
    exports:[RouterModule]
})
export class HomeHealthAgencyModuleRoutingModule { }